// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Cases Components Styles
 * 
 * Styles for the Cases management pages including:
 * - CasesComplex
 * - CasesPending
 * - CasesWorking
 * - CasesUnprocessed (RecordsApp)
 */

 .cases-container {
    padding: 20px 30px;
    background-color: #1a2332;
    min-height: calc(100vh - 70px);
    color: white;
    margin-top: 10px;
  }
  
  .cases-title {
    font-size: 1.875rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
    color: #e0e0e0;
    text-align: center;
  }
  
  .cases-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1.5rem;
  }
  
  @media (min-width: 768px) {
    .cases-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (min-width: 1024px) {
    .cases-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  .case-card {
    cursor: pointer;
    background-color: #2d3748;
    border: 1px solid #4a5568;
    border-radius: 8px;
    padding: 1rem 1.25rem;
    transition: box-shadow 0.3s ease, transform 0.2s ease;
  }
  
  .case-card:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }
  
  .case-card-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: white;
    margin: 0;
  }
  
  .cases-loading {
    color: #9ca3af;
    text-align: center;
    padding: 40px;
  }
  
  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
  }
  
  .modal-content {
    background-color: #1f2937;
    border: 1px solid #4a5568;
    border-radius: 12px;
    max-width: 600px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    padding: 1.5rem;
    color: white;
  }
  
  .modal-header {
    margin-bottom: 1.5rem;
  }
  
  .modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .modal-body {
    margin-bottom: 1rem;
  }
  
  .case-detail-section {
    margin-bottom: 1rem;
  }
  
  .case-detail-label {
    font-weight: 600;
    font-size: 1.125rem;
    color: white;
    margin-bottom: 0.25rem;
  }
  
  .case-detail-text {
    color: #d1d5db;
    font-size: 1rem;
    white-space: pre-wrap;
    margin: 0;
  }
  
  .modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #4a5568;
  }
  
  .modal-actions-left {
    display: flex;
    gap: 0.5rem;
  }
  
  .modal-actions-right {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  
  /* Input Styles */
  .cases-input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    background-color: #374151;
    border: 1px solid #4b5563;
    border-radius: 6px;
    color: white;
    font-size: 1rem;
    margin-top: 0.25rem;
  }
  
  .cases-input:focus {
    outline: none;
    border-color: #3b82f6;
  }
  
  .cases-textarea {
    width: 100%;
    padding: 0.5rem 0.75rem;
    background-color: #374151;
    border: 1px solid #4b5563;
    border-radius: 6px;
    color: white;
    font-size: 1rem;
    resize: vertical;
    margin-top: 0.25rem;
    min-height: 100px;
  }
  
  .cases-textarea:focus {
    outline: none;
    border-color: #3b82f6;
  }
  
  /* Button Styles */
  .btn {
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    transition: background-color 0.2s ease;
  }
  
  .btn-primary {
    background-color: #3b82f6;
    color: white;
  }
  
  .btn-primary:hover {
    background-color: #2563eb;
  }
  
  .btn-secondary {
    background-color: #4b5563;
    color: white;
  }
  
  .btn-secondary:hover {
    background-color: #6b7280;
  }
  
  .btn-success {
    background-color: #22c55e;
    color: white;
  }
  
  .btn-success:hover {
    background-color: #16a34a;
  }
  
  .btn-danger {
    background-color: #ef4444;
    color: white;
  }
  
  .btn-danger:hover {
    background-color: #dc2626;
  }
  
  .btn-warning {
    background-color: #eab308;
    color: white;
  }
  
  .btn-warning:hover {
    background-color: #ca8a04;
  }
  
  .btn-info {
    background-color: #3b82f6;
    color: white;
  }
  
  .btn-info:hover {
    background-color: #2563eb;
  }
  
  .btn-outline {
    background-color: transparent;
    border: 1px solid #4b5563;
    color: #d1d5db;
  }
  
  .btn-outline:hover {
    background-color: #374151;
  }
  
  /* Accordion Styles */
  .accordion {
    margin-top: 1rem;
    border-top: 1px solid #4a5568;
    padding-top: 1rem;
  }
  
  .accordion-item {
    border: 1px solid #4a5568;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .accordion-trigger {
    width: 100%;
    padding: 0.75rem 1rem;
    background-color: #374151;
    color: white;
    font-size: 1.125rem;
    font-weight: 500;
    cursor: pointer;
    border: none;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .accordion-trigger:hover {
    background-color: #4b5563;
  }
  
  .accordion-trigger::after {
    content: '▼';
    font-size: 0.75rem;
    transition: transform 0.2s ease;
  }
  
  .accordion-trigger.open::after {
    transform: rotate(180deg);
  }
  
  .accordion-content {
    padding: 1rem;
    background-color: #1f2937;
    border-top: 1px solid #4a5568;
  }
  
  .accordion-content.hidden {
    display: none;
  }
  
  /* Analysis Section */
  .analysis-section {
    padding: 1rem;
    border: 1px solid #4a5568;
    border-radius: 8px;
    background-color: rgba(55, 65, 81, 0.5);
  }
  
  .analysis-title {
    font-weight: 600;
    font-size: 1.125rem;
    color: white;
    margin-bottom: 1rem;
  }
  
  .analysis-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
  
  @media (min-width: 768px) {
    .analysis-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  .analysis-field {
    margin-bottom: 0.5rem;
  }
  
  .analysis-label {
    font-size: 0.875rem;
    color: #9ca3af;
    margin-bottom: 0.25rem;
  }
  
  /* Toast Notification */
  .toast-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 2000;
  }
  
  .toast {
    padding: 1rem 1.5rem;
    border-radius: 8px;
    margin-top: 0.5rem;
    animation: slideIn 0.3s ease;
  }
  
  .toast-success {
    background-color: #22c55e;
    color: white;
  }
  
  .toast-error {
    background-color: #ef4444;
    color: white;
  }
  
  .toast-info {
    background-color: #3b82f6;
    color: white;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  /* RecordsApp Specific Styles */
  .records-container {
    padding: 20px;
    background-color: #1f2937;
    min-height: calc(100vh - 70px);
    color: white;
  }
  
  .records-filters {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    align-items: center;
  }
  
  .records-filter-input {
    padding: 0.5rem 0.75rem;
    background-color: #374151;
    border: 1px solid #4b5563;
    border-radius: 6px;
    color: white;
    min-width: 200px;
  }
  
  .records-filter-select {
    padding: 0.5rem 0.75rem;
    background-color: #374151;
    border: 1px solid #4b5563;
    border-radius: 6px;
    color: white;
  }
  
  .records-filter-checkbox {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .records-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .records-table th,
  .records-table td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid #374151;
  }
  
  .records-table th {
    border-bottom: 1px solid #4b5563;
    font-weight: 600;
  }
  
  .records-table tr:hover {
    background-color: #374151;
  }
  
  .records-table .truncate {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .records-pagination {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
  }
  
  /* Record Modal Specific */
  .record-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .record-modal {
    background-color: #374151;
    border-radius: 8px;
    padding: 1.5rem;
    max-width: 1200px;
    width: 95%;
    max-height: 95vh;
    overflow-y: auto;
    position: relative;
  }
  
  .record-modal-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    color: #9ca3af;
    font-size: 1.5rem;
    cursor: pointer;
  }
  
  .record-modal-close:hover {
    color: white;
  }
  
  .record-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  
  .record-modal-title {
    font-size: 1.25rem;
    font-weight: bold;
  }
  
  .record-field {
    margin-bottom: 1rem;
  }
  
  .record-field label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 0.25rem;
  }
  
  .record-field textarea {
    width: 100%;
    padding: 0.5rem;
    background-color: #1f2937;
    border: 1px solid #4b5563;
    border-radius: 6px;
    color: white;
    resize: vertical;
  }
  
  .record-field textarea:read-only {
    background-color: #111827;
  }
  
  .similar-records {
    margin-top: 1.5rem;
  }
  
  .similar-records h4 {
    font-size: 1.125rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  
  .similar-record-item {
    background-color: #374151;
    border-radius: 8px;
    margin-bottom: 0.75rem;
  }
  
  .similar-record-summary {
    padding: 0.75rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .similar-record-summary:hover {
    background-color: #4b5563;
    border-radius: 8px;
  }
  
  .similar-record-details {
    padding: 1rem;
    border-top: 1px solid #4b5563;
  }
  
  .similar-record-details pre {
    font-size: 0.875rem;
    white-space: pre-wrap;
    font-family: inherit;
    background-color: #1f2937;
    padding: 0.5rem;
    border-radius: 6px;
  }
  
  .similar-record-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.75rem;
  }
  
  .alert-success {
    background-color: #065f46;
    border: 1px solid #047857;
    color: white;
    padding: 0.75rem 1rem;
    border-radius: 6px;
    margin-bottom: 1rem;
  }
  
  .alert-error {
    background-color: #7f1d1d;
    border: 1px solid #991b1b;
    color: white;
    padding: 0.75rem 1rem;
    border-radius: 6px;
    margin-bottom: 1rem;
  }
  
  /* Confirm Dialog */
  .confirm-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
  }
  
  .confirm-dialog {
    background-color: #1f2937;
    border: 1px solid #4b5563;
    border-radius: 12px;
    padding: 1.5rem;
    max-width: 400px;
    width: 90%;
  }
  
  .confirm-dialog-title {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .confirm-dialog-description {
    color: #9ca3af;
    margin-bottom: 1rem;
  }
  
  .confirm-dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/cases/Cases.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;CAED;IACG,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,qDAAqD;EACvD;;EAEA;IACE,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;EACf;;EAEA,iBAAiB;EACjB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA,kBAAkB;EAClB;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,sBAAsB;EACxB;;EAEA,uBAAuB;EACvB;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,WAAW;EACb","sourcesContent":["/**\r\n * Cases Components Styles\r\n * \r\n * Styles for the Cases management pages including:\r\n * - CasesComplex\r\n * - CasesPending\r\n * - CasesWorking\r\n * - CasesUnprocessed (RecordsApp)\r\n */\r\n\r\n .cases-container {\r\n    padding: 20px 30px;\r\n    background-color: #1a2332;\r\n    min-height: calc(100vh - 70px);\r\n    color: white;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .cases-title {\r\n    font-size: 1.875rem;\r\n    font-weight: bold;\r\n    margin-bottom: 1.5rem;\r\n    color: #e0e0e0;\r\n    text-align: center;\r\n  }\r\n  \r\n  .cases-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(1, 1fr);\r\n    gap: 1.5rem;\r\n  }\r\n  \r\n  @media (min-width: 768px) {\r\n    .cases-grid {\r\n      grid-template-columns: repeat(2, 1fr);\r\n    }\r\n  }\r\n  \r\n  @media (min-width: 1024px) {\r\n    .cases-grid {\r\n      grid-template-columns: repeat(3, 1fr);\r\n    }\r\n  }\r\n  \r\n  .case-card {\r\n    cursor: pointer;\r\n    background-color: #2d3748;\r\n    border: 1px solid #4a5568;\r\n    border-radius: 8px;\r\n    padding: 1rem 1.25rem;\r\n    transition: box-shadow 0.3s ease, transform 0.2s ease;\r\n  }\r\n  \r\n  .case-card:hover {\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\r\n    transform: translateY(-2px);\r\n  }\r\n  \r\n  .case-card-title {\r\n    font-size: 1.125rem;\r\n    font-weight: 600;\r\n    color: white;\r\n    margin: 0;\r\n  }\r\n  \r\n  .cases-loading {\r\n    color: #9ca3af;\r\n    text-align: center;\r\n    padding: 40px;\r\n  }\r\n  \r\n  /* Modal Styles */\r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .modal-content {\r\n    background-color: #1f2937;\r\n    border: 1px solid #4a5568;\r\n    border-radius: 12px;\r\n    max-width: 600px;\r\n    width: 100%;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n    padding: 1.5rem;\r\n    color: white;\r\n  }\r\n  \r\n  .modal-header {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n  \r\n  .modal-title {\r\n    font-size: 1.25rem;\r\n    font-weight: 600;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .modal-body {\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .case-detail-section {\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .case-detail-label {\r\n    font-weight: 600;\r\n    font-size: 1.125rem;\r\n    color: white;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n  \r\n  .case-detail-text {\r\n    color: #d1d5db;\r\n    font-size: 1rem;\r\n    white-space: pre-wrap;\r\n    margin: 0;\r\n  }\r\n  \r\n  .modal-footer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 0.5rem;\r\n    margin-top: 1.5rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid #4a5568;\r\n  }\r\n  \r\n  .modal-actions-left {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .modal-actions-right {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  /* Input Styles */\r\n  .cases-input {\r\n    width: 100%;\r\n    padding: 0.5rem 0.75rem;\r\n    background-color: #374151;\r\n    border: 1px solid #4b5563;\r\n    border-radius: 6px;\r\n    color: white;\r\n    font-size: 1rem;\r\n    margin-top: 0.25rem;\r\n  }\r\n  \r\n  .cases-input:focus {\r\n    outline: none;\r\n    border-color: #3b82f6;\r\n  }\r\n  \r\n  .cases-textarea {\r\n    width: 100%;\r\n    padding: 0.5rem 0.75rem;\r\n    background-color: #374151;\r\n    border: 1px solid #4b5563;\r\n    border-radius: 6px;\r\n    color: white;\r\n    font-size: 1rem;\r\n    resize: vertical;\r\n    margin-top: 0.25rem;\r\n    min-height: 100px;\r\n  }\r\n  \r\n  .cases-textarea:focus {\r\n    outline: none;\r\n    border-color: #3b82f6;\r\n  }\r\n  \r\n  /* Button Styles */\r\n  .btn {\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    border: none;\r\n    transition: background-color 0.2s ease;\r\n  }\r\n  \r\n  .btn-primary {\r\n    background-color: #3b82f6;\r\n    color: white;\r\n  }\r\n  \r\n  .btn-primary:hover {\r\n    background-color: #2563eb;\r\n  }\r\n  \r\n  .btn-secondary {\r\n    background-color: #4b5563;\r\n    color: white;\r\n  }\r\n  \r\n  .btn-secondary:hover {\r\n    background-color: #6b7280;\r\n  }\r\n  \r\n  .btn-success {\r\n    background-color: #22c55e;\r\n    color: white;\r\n  }\r\n  \r\n  .btn-success:hover {\r\n    background-color: #16a34a;\r\n  }\r\n  \r\n  .btn-danger {\r\n    background-color: #ef4444;\r\n    color: white;\r\n  }\r\n  \r\n  .btn-danger:hover {\r\n    background-color: #dc2626;\r\n  }\r\n  \r\n  .btn-warning {\r\n    background-color: #eab308;\r\n    color: white;\r\n  }\r\n  \r\n  .btn-warning:hover {\r\n    background-color: #ca8a04;\r\n  }\r\n  \r\n  .btn-info {\r\n    background-color: #3b82f6;\r\n    color: white;\r\n  }\r\n  \r\n  .btn-info:hover {\r\n    background-color: #2563eb;\r\n  }\r\n  \r\n  .btn-outline {\r\n    background-color: transparent;\r\n    border: 1px solid #4b5563;\r\n    color: #d1d5db;\r\n  }\r\n  \r\n  .btn-outline:hover {\r\n    background-color: #374151;\r\n  }\r\n  \r\n  /* Accordion Styles */\r\n  .accordion {\r\n    margin-top: 1rem;\r\n    border-top: 1px solid #4a5568;\r\n    padding-top: 1rem;\r\n  }\r\n  \r\n  .accordion-item {\r\n    border: 1px solid #4a5568;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .accordion-trigger {\r\n    width: 100%;\r\n    padding: 0.75rem 1rem;\r\n    background-color: #374151;\r\n    color: white;\r\n    font-size: 1.125rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    border: none;\r\n    text-align: left;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n  \r\n  .accordion-trigger:hover {\r\n    background-color: #4b5563;\r\n  }\r\n  \r\n  .accordion-trigger::after {\r\n    content: '▼';\r\n    font-size: 0.75rem;\r\n    transition: transform 0.2s ease;\r\n  }\r\n  \r\n  .accordion-trigger.open::after {\r\n    transform: rotate(180deg);\r\n  }\r\n  \r\n  .accordion-content {\r\n    padding: 1rem;\r\n    background-color: #1f2937;\r\n    border-top: 1px solid #4a5568;\r\n  }\r\n  \r\n  .accordion-content.hidden {\r\n    display: none;\r\n  }\r\n  \r\n  /* Analysis Section */\r\n  .analysis-section {\r\n    padding: 1rem;\r\n    border: 1px solid #4a5568;\r\n    border-radius: 8px;\r\n    background-color: rgba(55, 65, 81, 0.5);\r\n  }\r\n  \r\n  .analysis-title {\r\n    font-weight: 600;\r\n    font-size: 1.125rem;\r\n    color: white;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .analysis-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(1, 1fr);\r\n    gap: 1rem;\r\n  }\r\n  \r\n  @media (min-width: 768px) {\r\n    .analysis-grid {\r\n      grid-template-columns: repeat(2, 1fr);\r\n    }\r\n  }\r\n  \r\n  .analysis-field {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  \r\n  .analysis-label {\r\n    font-size: 0.875rem;\r\n    color: #9ca3af;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n  \r\n  /* Toast Notification */\r\n  .toast-container {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    z-index: 2000;\r\n  }\r\n  \r\n  .toast {\r\n    padding: 1rem 1.5rem;\r\n    border-radius: 8px;\r\n    margin-top: 0.5rem;\r\n    animation: slideIn 0.3s ease;\r\n  }\r\n  \r\n  .toast-success {\r\n    background-color: #22c55e;\r\n    color: white;\r\n  }\r\n  \r\n  .toast-error {\r\n    background-color: #ef4444;\r\n    color: white;\r\n  }\r\n  \r\n  .toast-info {\r\n    background-color: #3b82f6;\r\n    color: white;\r\n  }\r\n  \r\n  @keyframes slideIn {\r\n    from {\r\n      transform: translateX(100%);\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      transform: translateX(0);\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  /* RecordsApp Specific Styles */\r\n  .records-container {\r\n    padding: 20px;\r\n    background-color: #1f2937;\r\n    min-height: calc(100vh - 70px);\r\n    color: white;\r\n  }\r\n  \r\n  .records-filters {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n  }\r\n  \r\n  .records-filter-input {\r\n    padding: 0.5rem 0.75rem;\r\n    background-color: #374151;\r\n    border: 1px solid #4b5563;\r\n    border-radius: 6px;\r\n    color: white;\r\n    min-width: 200px;\r\n  }\r\n  \r\n  .records-filter-select {\r\n    padding: 0.5rem 0.75rem;\r\n    background-color: #374151;\r\n    border: 1px solid #4b5563;\r\n    border-radius: 6px;\r\n    color: white;\r\n  }\r\n  \r\n  .records-filter-checkbox {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .records-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .records-table th,\r\n  .records-table td {\r\n    padding: 0.75rem;\r\n    text-align: left;\r\n    border-bottom: 1px solid #374151;\r\n  }\r\n  \r\n  .records-table th {\r\n    border-bottom: 1px solid #4b5563;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .records-table tr:hover {\r\n    background-color: #374151;\r\n  }\r\n  \r\n  .records-table .truncate {\r\n    max-width: 400px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .records-pagination {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-top: 1rem;\r\n  }\r\n  \r\n  /* Record Modal Specific */\r\n  .record-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .record-modal {\r\n    background-color: #374151;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n    max-width: 1200px;\r\n    width: 95%;\r\n    max-height: 95vh;\r\n    overflow-y: auto;\r\n    position: relative;\r\n  }\r\n  \r\n  .record-modal-close {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    background: none;\r\n    border: none;\r\n    color: #9ca3af;\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .record-modal-close:hover {\r\n    color: white;\r\n  }\r\n  \r\n  .record-modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .record-modal-title {\r\n    font-size: 1.25rem;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .record-field {\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .record-field label {\r\n    display: block;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n  \r\n  .record-field textarea {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    background-color: #1f2937;\r\n    border: 1px solid #4b5563;\r\n    border-radius: 6px;\r\n    color: white;\r\n    resize: vertical;\r\n  }\r\n  \r\n  .record-field textarea:read-only {\r\n    background-color: #111827;\r\n  }\r\n  \r\n  .similar-records {\r\n    margin-top: 1.5rem;\r\n  }\r\n  \r\n  .similar-records h4 {\r\n    font-size: 1.125rem;\r\n    font-weight: bold;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  \r\n  .similar-record-item {\r\n    background-color: #374151;\r\n    border-radius: 8px;\r\n    margin-bottom: 0.75rem;\r\n  }\r\n  \r\n  .similar-record-summary {\r\n    padding: 0.75rem;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n  \r\n  .similar-record-summary:hover {\r\n    background-color: #4b5563;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .similar-record-details {\r\n    padding: 1rem;\r\n    border-top: 1px solid #4b5563;\r\n  }\r\n  \r\n  .similar-record-details pre {\r\n    font-size: 0.875rem;\r\n    white-space: pre-wrap;\r\n    font-family: inherit;\r\n    background-color: #1f2937;\r\n    padding: 0.5rem;\r\n    border-radius: 6px;\r\n  }\r\n  \r\n  .similar-record-actions {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    margin-top: 0.75rem;\r\n  }\r\n  \r\n  .alert-success {\r\n    background-color: #065f46;\r\n    border: 1px solid #047857;\r\n    color: white;\r\n    padding: 0.75rem 1rem;\r\n    border-radius: 6px;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .alert-error {\r\n    background-color: #7f1d1d;\r\n    border: 1px solid #991b1b;\r\n    color: white;\r\n    padding: 0.75rem 1rem;\r\n    border-radius: 6px;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  /* Confirm Dialog */\r\n  .confirm-dialog-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 2000;\r\n  }\r\n  \r\n  .confirm-dialog {\r\n    background-color: #1f2937;\r\n    border: 1px solid #4b5563;\r\n    border-radius: 12px;\r\n    padding: 1.5rem;\r\n    max-width: 400px;\r\n    width: 90%;\r\n  }\r\n  \r\n  .confirm-dialog-title {\r\n    font-size: 1.125rem;\r\n    font-weight: 600;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  \r\n  .confirm-dialog-description {\r\n    color: #9ca3af;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .confirm-dialog-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 0.5rem;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
